import { Component } from 'react';
import PropTypes from 'prop-types';

import { hasUnpublishedContent } from './../utils/cache';

// Calls onUnpublished after render whenever the content tree contains
// unpublished items. Keeps cache writes out of the render phase.
class UnpublishedContentCheck extends Component {
  componentDidMount() {
    this.check();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.items !== this.props.items) {
      this.check();
    }
  }

  check() {
    const { items, childFields, onUnpublished } = this.props;

    if (hasUnpublishedContent(items, childFields)) {
      onUnpublished();
    }
  }

  render() {
    return null;
  }
}

UnpublishedContentCheck.propTypes = {
  items: PropTypes.array.isRequired,
  childFields: PropTypes.array.isRequired,
  onUnpublished: PropTypes.func.isRequired
};

export default UnpublishedContentCheck;
